import { ref, watch } from 'vue'

export function useTheme () {
  const isDarkMode = ref(false)

  const applyTheme = (isDark) => {
    // A magia do Bootstrap 5 acontece aqui!
    const theme = isDark ? 'dark' : 'light'
    document.documentElement.setAttribute('data-bs-theme', theme)
    localStorage.setItem('ct-comex-theme', theme)
  }

  const toggleTheme = () => {
    isDarkMode.value = !isDarkMode.value
  }

  const initTheme = () => {
    const savedTheme = localStorage.getItem('ct-comex-theme')
    if (savedTheme === 'dark') {
      isDarkMode.value = true
    } else if (!savedTheme && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      // Se não houver nada guardado, mas o Windows/Mac do utilizador estiver no modo escuro, adapta-se!
      isDarkMode.value = true
    } else {
      isDarkMode.value = false
    }
    applyTheme(isDarkMode.value)
  }

  // Sempre que a variável mudar, aplica as classes no HTML
  watch(isDarkMode, (newVal) => {
    applyTheme(newVal)
  })

  return {
    isDarkMode,
    toggleTheme,
    initTheme
  }
}
